module.exports = __webpack_public_path__ + "img/index1.03e20d02.png";